"use client";

import { useState } from "react";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { useDebouncedCallback } from "use-debounce";
import { AutoScrollSlider } from "@/app/components/carousel";
import { MainTitle } from "@/app/components/title/index";
import { DetailList } from "@/app/components/list/index";
import { message } from "antd";

export function WorkList({ data }: { data: [][] }) {
  const [current, setCurrent] = useState(0);

  const navLinks = [
    {
      name: "工作动态",
      link: "/information/dynamic",
    },
    {
      name: "通知公告",
      link: "/information/notify",
    },
  ];

  return (
    <div className="h-[48px] w-[510px] border-b-1">
      <ul className="flex">
        {navLinks.map((nav, index) => (
          <li
            key={nav.name}
            onMouseEnter={() => setCurrent(index)}
            className={clsx(
              "h-[49px] w-[130px] text-center leading-[49px] text-xl font-bold border-b-2 ",
              {
                "text-black": index !== current,
                "text-[#07408e] border-b-red-700": index === current,
              }
            )}
          >
            <Link href={nav.link} legacyBehavior passHref>
              <a target="_blank">{nav.name}</a>
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-[12px]">
        <DetailList
          list={data[current]}
          pathname={navLinks[current].link}
          divide={false}
          css={{
            lineHeight: "35px",
            height: "35px",
            fontSize: "16px",
          }}
        ></DetailList>
      </div>
    </div>
  );
}

export function Header() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const initialPlaceholder = "请输入搜索关键字";
  //   const [placeholder, setPlaceholder] = useState(initialPlaceholder);
  const [keyword, setKeyword] = useState("");

  const jumpTo = () => {
    if (!keyword.trim()) return message.warning("输入的关键字不能为空");
    const params = new URLSearchParams(searchParams);
    if (keyword) {
      params.set("keyword", keyword);
      params.set("page", "1");
      //   setPlaceholder(keyword);
    } else {
      params.delete("keyword");
    }
    router.push(`/search?${params.toString()}`);
  };

  const handleKeyDown = useDebouncedCallback((e) => {
    if (e.key == "Enter") {
      e.target.blur();
      jumpTo();
    }
  }, 300);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const previousSibling = (e.target as HTMLElement)
      .previousSibling! as HTMLInputElement;
    previousSibling.blur();
    jumpTo();
  };

  return (
    <header className="w-full bg-[url('/imgs/bg-header.gif')] bg-left-top bg-repeat-x">
      <div className="w-[1200px] h-[140px] mx-auto flex items-center justify-between">
        <div className="h-[79px] w-[279px] bg-[url('/imgs/logo.png')] bg-contain bg-no-repeat"></div>
        <div className="flex h-[38px] w-[355px] bg-[url('/imgs/bg-search.png')] bg-contain bg-no-repeat">
          <input
            type="text"
            placeholder={initialPlaceholder}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e)}
            className="w-[311px] h-full bg-transparent ml-[1em] indent-[15px] text-[14px]!"
            defaultValue={searchParams.get("keyword")?.toString()}
          />
          <button
            className="h-[38px] w-[44px] cursor-pointer"
            onClick={(e) => handleClick(e)}
          ></button>
        </div>
      </div>
    </header>
  );
}

// 专题图片
export function SubjectPicture({
  list,
  pathname,
  baseUrl,
}: {
  list: any[];
  pathname: string;
  baseUrl: string;
}) {
  return (
    <div className="flex w-[1200px] p-[20px] h-[130px] bg-[#f5f5f5]">
      {/* 专题图片 */}
      <div className="w-[90px] h-[94px] border-[1px] bg-[url('/imgs/topic.gif')] bg-no-repeat">
        <Link
          href={pathname}
          className="text-[20px] h-full flex flex-col items-center justify-center text-[20px]/[28px] text-[#07408e]"
        >
          <span>专题</span>
          <span>图片</span>
        </Link>
      </div>
      <div className="w-[0] grow ml-[20px]">
        <AutoScrollSlider num="4">
          {list.map((item) => (
            <Link
              href={`${pathname}?category=${item.name}`}
              legacyBehavior
              passHref
              key={item.documentId}
            >
              <a target="_blank">
                <Image
                  src={`${baseUrl}${item.cover.url}`}
                  alt={item.title || item.name}
                  width={252}
                  height={90}
                ></Image>
              </a>
            </Link>
          ))}
        </AutoScrollSlider>
      </div>
    </div>
  );
}

export function CultureDisplay({ list, baseUrl }: { list: any[], baseUrl: string }) {
  const pathname = "/culture/display";
//   const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

  const handleClick = (category: string) => {
    const params = new URLSearchParams();
    params.set("category", category);

    window.open(`${pathname}?${params.toString()}`, "_blank");
  };

  return (
    <div>
      <MainTitle title="档案展览" pathname={pathname}></MainTitle>
      <div className="mt-[20px] w-[530px]">
        <ul className="flex justify-between">
          {list.map((item: any) => (
            <li
              key={item.documentId}
              className="w-[131px] h-[218px] relative cursor-pointer"
              onClick={() => handleClick(item.name)}
              // style={{
              //   background: `url(${process.env.NEXT_PUBLIC_BASE_URL}${item.cover.url}) no-repeat cover`,
              // }}
            >
              {/* <Link
                href={`${pathname}?category=${item.name}`}
                target="_blank"
                className="w-[130px] h-[218px] relative cursor-pointer"
              > */}
              <Image
                src={`${baseUrl}${item.cover.url}`}
                alt={item.name}
                // width={131}
                // height={217}
                className="object-cover"
                fill
              ></Image>
              <span className="absolute w-full h-[44px] text-[16px]/[44px] text-center text-white bottom-0">
                {item.name}
              </span>
              {/* </Link> */}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export function FixedBox() {
  const pathname = usePathname();
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;

  return (
    (pathname.startsWith("/people") || pathname.startsWith("/archive")) && (
      <div className="fixed right-[70px] top-[290px] w-[140px] h-[80px]">
        <Link
          href="/people/satisfaction"
          className="h-full rounded-[10px] text-white px-[15px] text-[20px]/[26px] flex flex-col justify-center items-center"
          style={{
            background: "linear-gradient(to top right, #6FC9FF, #3E87FF)",
          }}
        >
          <div>档案服务</div>
          <div>满意度测评</div>
        </Link>

        <button
          className="cursor-pointer absolute top-[-19px] right-[5px]"
          onClick={() => setHidden(true)}
        >
          <Image
            src="/imgs/close.png"
            alt="关闭按钮"
            width={30}
            height={10}
          ></Image>
        </button>
      </div>
    )
  );
}
